<h2 mat-dialog-title>Choose verification method</h2>
<mat-dialog-content>
  <div class="option" (click)="selectMethod('email')">
    <mat-icon class="icon">mail</mat-icon>
    <div>
      <p class="title"> <strong>Email</strong></p>
      <p class="subTitle">Receive a code via email</p>
    </div>
    <mat-icon class="arrow">chevron_right</mat-icon>
  </div>

  <div class="option" (click)="selectMethod('sms')">
    <mat-icon class="icon">chat</mat-icon>
    <div>
      <p class="title"> <strong>SMS</strong></p>
      <p class="subTitle">Receive a code via text message</p>
    </div>
    <mat-icon class="arrow">chevron_right</mat-icon>
  </div>
</mat-dialog-content>